(function () {

    "use strict";

    function routeGenerator(URL) {
        var that = this;

        that.generateApiRoute = generateApiRoute;

        function generateApiRoute(route) {            
            var prefix = "/api/";
            return URL.URL + prefix + route;
        }     
    }

    routeGenerator.$inject = ["URL"];

    angular.module("sphForms.auth").service("sphForms.routeGenerator", routeGenerator);

})();